import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center space-y-4"
}
const _hoisted_2 = { class: "flex flex-col items-center justify-center" }
const _hoisted_3 = { class: "w-full" }

import TextField from '@/components/Inputs/TextField.vue';
import { useFactionsStore } from '@/store/factions';
import { Faction } from '@/typings/faction';
import { cloneDeep } from 'lodash';
import { inject, onMounted, Ref, ref } from 'vue';
import Button from '@/components/UI/Button.vue';
import { AlertModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useFactionsStore();
const editingFaction = ref<Faction>();

const file = ref<HTMLInputElement | null>(null);

function imageChanged() {
  if (file.value && file.value.files && editingFaction.value) {
    const uploaded = file.value.files[0];
    editingFaction.value.Image = uploaded;
    const reader = new FileReader();
    reader.onloadend = () => {
      const element = document.querySelector('.image') as HTMLDivElement;
      if (element && element.style) {
        element.style.backgroundImage = `url(${reader.result})`;
      }
    };
    reader.readAsDataURL(uploaded);
  }
}

const alertModal = inject('alertModal') as Ref<AlertModal>;

async function save() {
  if (editingFaction.value) {
    await store.putFaction(editingFaction.value);
    alertModal.value.show(
      'Faction Saved',
      'Your faction settings have been saved.'
    );
  }
}

onMounted(() => {
  if (store.faction) {
    editingFaction.value = cloneDeep(store.faction);
  }
});

return (_ctx: any,_cache: any) => {
  return (editingFaction.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TextField, {
          title: "Faction Name",
          modelValue: editingFaction.value.Name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingFaction.value.Name) = $event)),
          "max-length": 36
        }, null, 8, ["modelValue"]),
        _createVNode(TextField, {
          modelValue: editingFaction.value.Description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editingFaction.value.Description) = $event)),
          title: "Description",
          "max-length": 200,
          multiline: ""
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "w-40 h-40 bg-center bg-cover border-2 rounded-full image border-primary",
            style: _normalizeStyle({
          'background-image': 'url()',
        })
          }, null, 4),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              ref: (_value, _refs) => {
                _refs['file'] = _value
                file.value = _value
              },
              type: "file",
              onChange: imageChanged
            }, null, 544)
          ])
        ]),
        _createVNode(Button, {
          label: "Save Changes",
          onClick: save
        })
      ]))
    : _createCommentVNode("", true)
}
}

})